import React from 'react';

const Credits = () => {
    return (
        <p className="main_content_footer">
            Habbo is a registered trademark of Sulake Oy. All rights reserved to their respective owners.
            <br />
            <span style={{fontFamily: "'Volter'", fontSize: '9px'}}>Made with | by Relevance. Follow me on <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/josednn/">instagram</a>.</span>
        </p>
    );
};

export default Credits;